import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getSearchResultsFlights } from "../store/searchResults/selectors.js";
import { getFareOffersWithDetails } from "../store/brandedFareOffers/selectors.js";
export default function useFlightOfferInSearchResults() {
    const flights = useSelector(getSearchResultsFlights);
    const brandedFaresStore = useSelector(getFareOffersWithDetails);
    const getTotalPrice = useCallback((id, baseOfferToken) => {
        if (!id)
            return undefined;
        if (baseOfferToken) {
            if (brandedFaresStore[baseOfferToken]) {
                const fares = brandedFaresStore[baseOfferToken];
                const priceExistsInBrandedFareOffer = fares.brandedFareOffers?.find((offer) => offer.token === id)
                    ?.priceBreakdown?.total;
                if (priceExistsInBrandedFareOffer)
                    return priceExistsInBrandedFareOffer;
            }
        }
        return flights.find((flight) => flight.token === id)?.priceBreakdown?.total;
    }, [flights, brandedFaresStore]);
    return { getTotalPrice };
}
